<template>
  <div class="top">
    <icon-back class="back" color="rgba(33, 34, 39, 1)" @back="back"></icon-back>
    <!-- <a-switch v-model="switchValue" :checked-children="switchValue ? checkedChildren : ''" :un-checked-children="switchValue ? '':unCheckedChildren">
    </a-switch> -->
    <strong>{{ title }}</strong>
  </div>
</template>

<script>

import IconBack from '@comp/Icon/IconBack'
import Sun from '@comp/Icon/Sun'
import Moon from '@comp/Icon/Moon'
export default {
  name: 'NewHeader',
  components: { IconBack, Sun, Moon },
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  data() {
    return {
      switchValue: false,
      checkedChildren: <sun></sun>,
      unCheckedChildren: <moon></moon>,
    }
  },
  methods: {
    back() {
      if (this.$listeners.back) {
        this.$emit('back');
      } else {
        this.$router.back()
      }
    },
  }
}
</script>
<style lang="less" scoped>
.top {
  height: 41px;
  position: relative;
  border-bottom: 1px solid rgba(223, 225, 229, 1);

  .back {
    position: absolute;
    left: 20px;
    top: 10px;
  }

  button {
    position: absolute;
    left: 50px;
    top: 8px;
    // background-color: #376eff;
    background-color: rgba(203, 229, 252, 1);
  }

  strong {
    display: block;
    height: 100%;
    line-height: 41px;
    font-size: 16px;
    color: rgba(33, 34, 39, 1);
    text-align: center;
  }
}
</style>
